<template>
  <div class="backdrop">
    <div class="logo">Otti</div>
    <div class="button-bar">
      <router-link to="/signup">
        <button class="sign-up-btn">{{ signUpText }}</button>
      </router-link>
      <router-link to="/login">
        <button class="sign-in-btn">{{ signInText }}</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import bus from '@/bus.js'
export default {
  data() {
    return {
      signUpText: "Sign up",
      signInText: "Log in",
    };
  },
  mounted() {
    bus.$emit("hide-loader");
  }
};
</script>

<style scoped lang="scss">
@use '../styles/theme.scss';

.logo {
  font-family: theme.$font-family-logo;
  font-weight: 900;
  color: theme.$white-background;
  font-size: 80px;
  position: relative;
  transform: translateY(-50%);
  top: 50%;
  text-align: center;
  animation: anim-logo 0.5s ease-out 2s 1 normal forwards;
  -webkit-animation: anim-logo 0.5s ease-out 2s 1 normal forwards;
}

.backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: theme.$primary-color;
  padding: theme.$page-padding-X;
}

.sign-up-btn,
.sign-in-btn {
  color: theme.$primary-color;
  background: theme.$white-background;
  border: 0;
  border-radius: theme.$button-border-radius;
  width: 100%;
  font-size: 16px;
  text-align: center;
  padding-top: 16px;
  padding-bottom: 16px;
  box-sizing: border-box;
  margin-top: 16px;
}
.sign-in-btn {
  color: theme.$white-background;
  background-color: theme.$primary-color;
  border: 1px solid theme.$white-background;
}

.button-bar {
  opacity: 0;
  position: absolute;
  bottom: theme.$page-padding-bottom;
  width: 100%;
  margin-left: - theme.$page-padding-X;
  padding: 0px theme.$page-padding-X;
  animation: anim-btns 1s linear 2s 1 normal forwards;
  -webkit-animation: anim-btns 1s linear 2s 1 normal forwards;
}

@keyframes anim-logo {
  0% {
    top: 50%;
  }
  100% {
    top: calc(50% - 100px);
  }
}

@keyframes anim-btns {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 768px) {
  .logo {
    color: theme.$primary-color;
  }
  .backdrop {
    background-color: theme.$white-background;
  }

  .sign-up-btn {
    color: theme.$white-background;
    background-color: theme.$primary-color;
    border: 1px solid theme.$white-background;
  }

  .sign-in-btn {
    color: theme.$primary-color;
    background-color: theme.$white-background;
    border: 1px solid theme.$primary-color;
  }

  .button-bar {
    transform: translate(-50%, -50%);
    top: 60%;
    left: 50%;
    bottom: initial;
    text-align: center;
    margin: 0 auto;
    padding: 0;
    width: 200px;
  }
}
</style>
